import 'element-closest-polyfill';
import logError from '../util/logError';

/**
 * Adds an event listener on the document that catches events bubbling up from a given target.
 * When an event is thrown, it looks for the closest target which matches the selector and provides
 * that as the `this` of the callback.
 *
 * The greatest benefit of this is it allows us to define event listeners before the dom is loaded,
 * and they will automatically be available whenever any element is added with the given selector.
 *
 * @param eventName - The name of the event to listen on
 * @param targetSelector - The selector of the closest target to match on the event
 * @param callback - The callback for the event
 */
export default function(eventName, targetSelector, callback) {
  document.addEventListener(eventName, function (event) {
    try {
      let target;
      if(typeof event.target.closest == 'function') {
        target = event.target.closest(targetSelector);
      }
      if(target) callback.call(target, event);
    } catch(err) {
      logError(err, { eventName, targetSelector });
    }
  });
}
